import { render, staticRenderFns } from "./questionsDetail.vue?vue&type=template&id=6613fb6a&scoped=true"
import script from "./questionsDetail.vue?vue&type=script&lang=js"
export * from "./questionsDetail.vue?vue&type=script&lang=js"
import style0 from "./questionsDetail.vue?vue&type=style&index=0&id=6613fb6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6613fb6a",
  null
  
)

export default component.exports